import { Factory } from '../interface/factory'
import { applyEntitySchema, parseEntity, sourceJson } from '../../_utils/fcdc-v2'
import { emailSchema } from '../schema/identity.schema'

export enum EmailStatus {
  Unverified = 'Unverified',
  PendingVerification = 'PendingVerification',
  Verified = 'Verified',
}

export abstract class Email {
  status: EmailStatus
  address: string

  constructor(json: any, status: EmailStatus) {
    this.status = status
    this.address = json.address
  }

  protected attachEmail(json: unknown): void {
    applyEntitySchema(this, emailSchema, sourceJson(json), {})
  }

  static getFactory(): Factory<Email> {
    return new (class implements Factory<Email> {
      make(json: any): Email {
        switch (json.status) {
          case EmailStatus.Unverified:
            return new UnverifiedEmail(json)
          case EmailStatus.PendingVerification:
            return new PendingEmail(json)
          case EmailStatus.Verified:
            return new VerifiedEmail(json)
          default:
            return parseEntity(emailSchema, json ?? {}) as unknown as Email
        }
      }

      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on a Email. Emails are not stored in IndexDB.'
        )
      }
    })()
  }
}

export class UnverifiedEmail extends Email {
  constructor(json: any) {
    const source = sourceJson(json) as any
    super(source, EmailStatus.Unverified)
    this.attachEmail(source)
  }
}

export class PendingEmail extends Email {
  code: string
  constructor(json: any) {
    const source = sourceJson(json) as any
    super(source, EmailStatus.PendingVerification)
    this.code = source.code
    this.attachEmail(source)
  }
}

export class VerifiedEmail extends Email {
  constructor(json: any) {
    const source = sourceJson(json) as any
    super(source, EmailStatus.Verified)
    this.attachEmail(source)
  }
}
